import { render, staticRenderFns } from "./ParticipationInfo.vue?vue&type=template&id=5dd68daa&"
import script from "./ParticipationInfo.vue?vue&type=script&lang=js&"
export * from "./ParticipationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports